export default () => {
  document.addEventListener("turbolinks:load", () => {
    const tabs = document.querySelectorAll('.user-tabs .user-tab-item');

    if (!tabs) {
      return;
    }

    const contents = document.querySelectorAll('.user-contents .user-content');

    // URLパラメータからタブを取得して初期選択
    const urlParams = new URLSearchParams(window.location.search);
    const initialTab = urlParams.get('tab');
    if (initialTab) {
      const targetTab = document.querySelector(`.user-tabs .user-tab-item.${initialTab}`);
      if (targetTab) {
        tabs.forEach((tab) => tab.classList.remove('selected'));
        contents.forEach((content) => content.classList.remove('selected'));

        targetTab.classList.add('selected');
        const targetContent = document.querySelector(`.user-contents .user-content.${initialTab}`);
        if (targetContent) {
          targetContent.classList.add('selected');
        }
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((tab) => {
          tab.classList.remove('selected')
        });

        const selectedTab = tab.className.split(' ').pop();
        tab.classList.add('selected');

        contents.forEach((content) => {
          if (content.classList.contains(selectedTab)) {
            content.classList.add('selected')
          } else {
            content.classList.remove('selected')
          }
        });
      });
    });
  });
};
